import React from 'react';
import styles from './stateTableCell.module.scss';
import { Status } from 'components/Status/Status';
import { withHintButton } from './hoc/withHintButton';
import { withIconButton } from './hoc/withIconButton';

type StateTableCellProps = {
  stateData: {
    des: string;
    color: string;
    extraInfo?: string;
  };
};

export const StateTableCell: React.FC<StateTableCellProps> = ({
  stateData
}) => {
  return (
    <div className={styles.tableCell}>
      <Status
        label={stateData.des}
        color={stateData.color}
        renderExtraInfo={
          stateData.extraInfo ? () => stateData.extraInfo : undefined
        }
      />
    </div>
  );
};

export const StateTableCellWithHint = withHintButton<StateTableCellProps>(
  StateTableCell,
  styles.iconButton
);

export const StateTableCellWithIconButton =
  withIconButton<StateTableCellProps>(StateTableCell);
